import { clearAppCacheAndReload } from './clearAppCache';

const ASSET_RECOVERY_RELOAD_KEY = 'asset-recovery-reload-attempted';

export function isAssetVersionMismatchError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? '');
  return (
    /Unable to preload CSS/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message) ||
    /Loading chunk [\d]+ failed/i.test(message) ||
    /ChunkLoadError/i.test(message)
  );
}

export async function tryRecoverFromAssetMismatch(error: unknown): Promise<boolean> {
  if (!isAssetVersionMismatchError(error)) return false;
  if (typeof window === 'undefined') return false;
  if (!navigator.onLine) return false;

  const alreadyReloaded = sessionStorage.getItem(ASSET_RECOVERY_RELOAD_KEY) === '1';
  if (alreadyReloaded) return false;

  sessionStorage.setItem(ASSET_RECOVERY_RELOAD_KEY, '1');
  await clearAppCacheAndReload();
  return true;
}

export async function forceAssetRefresh(): Promise<void> {
  sessionStorage.removeItem(ASSET_RECOVERY_RELOAD_KEY);
  await clearAppCacheAndReload();
}

export function markAssetRecoverySuccess(): void {
  if (typeof window === 'undefined') return;
  window.setTimeout(() => {
    sessionStorage.removeItem(ASSET_RECOVERY_RELOAD_KEY);
  }, 1500);
}
